import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { ReactComponent as AttachIcon } from "../../Assets/icons/attach.svg";
import Input from "../../Components/Input";

const DocumentUpload = ({
  items,
  label,
  hint,
  onDownload,
  onUpload,
  onFileRemove,
  error,
  required = false,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const addLabel = t("DOCUMENT_UPLOAD.ADD", "Ajouter");
  const removeLabel = t("DOCUMENT_UPLOAD.REMOVE", "Supprimer");

  if (!isEmpty(items)) {
    return (
      <div className="acoris__document-upload">
        {items.map((item) => {
          const itemKey = item?.uid || item?.id || item?.name;
          return (
            <div
              key={itemKey}
              className="acoris__document-upload--row acoris__document-upload--row--filled"
            >
              <div className="acoris__document-upload--content">
                <span
                  className="acoris__document-upload--icon"
                  aria-hidden="true"
                >
                  <AttachIcon />
                </span>
                <button
                  type="button"
                  className="acoris__document-upload--file-name"
                  onClick={() => onDownload?.(item)}
                >
                  {item?.name || ""}
                </button>
              </div>
              <button
                type="button"
                className="acoris__document-upload--remove"
                onClick={() => onFileRemove(item)}
              >
                {removeLabel}
              </button>
            </div>
          );
        })}
        {error && (
          <span className="acoris__document-upload--error">{error}</span>
        )}
      </div>
    );
  }

  return (
    <div className="acoris__document-upload">
      <div className="acoris__document-upload--row">
        <div className="acoris__document-upload--content">
          <span className="acoris__document-upload--icon" aria-hidden="true">
            <AttachIcon />
          </span>
          <div className="acoris__document-upload--label-area">
            <span className="acoris__document-upload--label-text">{label}</span>
            {required && (
              <span
                className="acoris__document-upload--asterisk"
                aria-hidden="true"
              >
                *
              </span>
            )}
          </div>
        </div>
        <Input
          type="file"
          variant="uploader"
          showUploadList={false}
          fileList={items || []}
          onUpload={onUpload}
          className="acoris__document-upload--input"
        >
          <span className="acoris__document-upload--add">{addLabel}</span>
        </Input>
      </div>
      {hint && <span className="acoris__document-upload--hint">{hint}</span>}
      {error && <span className="acoris__document-upload--error">{error}</span>}
    </div>
  );
};

export default DocumentUpload;
